<template>
  <div class="product__card">
    <img :src="product?.thumbnail" alt="" class="product__card-img" />

    <div class="product__card-desc">
      <h3 class="product__card-desc-title">{{ product?.title }}</h3>

      <p class="product__card-desc-txt">{{ product?.description }}</p>

      <button
        class="product__card-desc-btn"
        @click="$store.commit('setCart', product?.id)"
      >
        Add to cart
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "Card",
  props: {
    product: {
      type: Array,
    },
  },
};
</script>
